export default __webpack_public_path__ + "static/media/dash.fb32fe6c.png";